// src/infrastructure/apiClient.js
import axios from 'axios';
import config from './config';

const apiClient = axios.create({
    baseURL: config.apiBaseUrl,
    headers: config.headers,
});

export default apiClient;